import { Path } from '@kistill/client/shared/ui'

export const listItems: Path[] = [
  { label: 'Upprunar', to: 'uppruni', icon: 'inventory_2' },
  { label: 'Aðföng', to: 'adfang', icon: 'layers' },
  {
    label: 'Eintök',
    to: 'eintak',
    icon: 'article',
  },
  {
    label: 'Efnisgreining',
    to: 'efnisgreining',
    icon: 'subtitles',
  },
  {
    label: 'Frumtitlar',
    to: 'frumtitill',
    icon: 'movie',
  },
  {
    label: 'Titlar',
    to: 'titill',
    icon: 'local_movies',
  },
  {
    label: 'Kredit',
    to: 'kredit',
    icon: 'theater_comedy',
  },
  {
    label: 'Aðilar',
    to: 'adilar',
    icon: 'people_alt',
  },
]
